export const PLATFORM_ADMIN_ROLES = ['super_admin', 'super_user'];

export const SUPER_VISOR_ROLE = 'super_visor';
export const ASSISTANT_SUPER_VISOR_ROLE = 'assistant_super_visor';
export const PROJECT_MANAGER_ROLE = 'project_manager';

export const SUPERVISOR_LABEL = 'Supervisor';
export const ASSISTANT_SUPERVISOR_LABEL = 'Assistant Supervisor';
export const PROJECT_MANAGER_LABEL = 'Project Manager';
export const USER_ROLE_LABEL = 'User/Worker';

export const SAFETY_SUPERVISOR_ROLES = [SUPER_VISOR_ROLE, ASSISTANT_SUPER_VISOR_ROLE];

/** Supervisor only — used in create/edit role dropdowns (Assistant Supervisor is sites-only). */
export const SAFETY_SUPERVISOR_ROLE_OPTIONS = [
  { value: SUPER_VISOR_ROLE, label: SUPERVISOR_LABEL },
];

export const PROJECT_MANAGER_ROLE_OPTION = {
  value: PROJECT_MANAGER_ROLE,
  label: PROJECT_MANAGER_LABEL,
};

export const ROLE_LABELS = {
  user: USER_ROLE_LABEL,
  admin: 'Admin',
  super_admin: 'Super Admin',
  super_user: 'Super User',
  [SUPER_VISOR_ROLE]: SUPERVISOR_LABEL,
  [ASSISTANT_SUPER_VISOR_ROLE]: ASSISTANT_SUPERVISOR_LABEL,
  [PROJECT_MANAGER_ROLE]: PROJECT_MANAGER_LABEL,
};

export const COMPANY_ADMIN_ROLE_OPTIONS = [
  { value: 'user', label: USER_ROLE_LABEL },
  { value: 'admin', label: 'Admin' },
  PROJECT_MANAGER_ROLE_OPTION,
  ...SAFETY_SUPERVISOR_ROLE_OPTIONS,
];

export const CLIENT_ROLE_OPTIONS = [
  { value: 'user', label: USER_ROLE_LABEL },
  { value: 'admin', label: 'Admin' },
  PROJECT_MANAGER_ROLE_OPTION,
  ...SAFETY_SUPERVISOR_ROLE_OPTIONS,
];

/** Count cards may still show existing Assistant Supervisor accounts. */
export const CLIENT_ROLE_STATS_OPTIONS = [
  ...CLIENT_ROLE_OPTIONS,
  { value: ASSISTANT_SUPER_VISOR_ROLE, label: ASSISTANT_SUPERVISOR_LABEL },
];

export const INTERNAL_ROLE_OPTIONS = [
  { value: 'user', label: USER_ROLE_LABEL },
  { value: 'admin', label: 'Admin' },
  PROJECT_MANAGER_ROLE_OPTION,
  { value: 'super_user', label: 'Super User' },
  ...SAFETY_SUPERVISOR_ROLE_OPTIONS,
  { value: 'super_admin', label: 'Super Admin' },
];

export const PLATFORM_ROLE_OPTIONS = [
  ...INTERNAL_ROLE_OPTIONS,
];

export function isPlatformAdmin(role) {
  return PLATFORM_ADMIN_ROLES.includes(role);
}

export function isSuperAdmin(role) {
  return role === 'super_admin';
}

export function isSuperUser(role) {
  return role === 'super_user';
}

export function isSafetySupervisorRole(role) {
  return SAFETY_SUPERVISOR_ROLES.includes(role);
}

export const SITE_ASSIGN_ROLES = ['super_visor', 'admin', 'super_admin', 'super_user'];

export const SITE_WORKER_ASSIGN_ROLES = ['admin', 'super_admin', 'super_user'];

export function canAssignSites(role) {
  return SITE_ASSIGN_ROLES.includes(role);
}

export function canAssignWorkers(role) {
  return SITE_WORKER_ASSIGN_ROLES.includes(role);
}

export function canManageSafetySupervisors(role) {
  return role === 'super_admin' || role === 'super_user' || role === 'admin';
}

export function isSuperVisor(role) {
  return role === SUPER_VISOR_ROLE;
}

export function isAssistantSuperVisor(role) {
  return role === ASSISTANT_SUPER_VISOR_ROLE;
}

export function isProjectManager(role) {
  return role === PROJECT_MANAGER_ROLE;
}

/** Roles above Supervisor (not supervisor/assistant/worker/PM). */
export function isAboveSupervisorRole(role) {
  return role === 'super_admin' || role === 'super_user' || role === 'admin';
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}

export function platformAdminRoleLabel(role) {
  return roleLabel(role);
}
